import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

export function loadChatBackgrounds(): void {
  const userId = Entities.usersStore.myId;
  if (!userId) {
    return;
  }

  const global = storage.chatBackgroundGlobal.get(userId);
  const byEntity = storage.chatBackgroundsByEntity.get(userId);

  Entities.appearance.setChatBackgroundGlobal(global);
  Entities.appearance.setChatBackgroundsByEntity(byEntity);
}
